import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';
import { ConfigName, deleteConfig } from '../common/config';
import { sqlConnectionProvider } from '../sqlConnectionProvider';

// This upgrade reverses version0001 and most of the data out of the native key/value storage
// and back into the SQLite database.

const upgrade = async () => {
  logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0003');
  const versionString = await sqlConnectionProvider.storageGet(ConfigName.Version);
  const version = parseInt(versionString || '0');
  if (version === 2) {
    await sqlConnectionProvider.storageSet(ConfigName.Version, '3');
    await deleteConfig(`${ConfigName.RepairOrderSync}`);
  } else {
    logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0003 not required');
  }
};

export default upgrade;
